'use client'

import ErrorPage from '@/components/ui/error-page';

export default function Error({
    error,
}: {
    error: Error & { digest?: string }    
}) {
    let errorProps = {
        code: 500,
        title: "Something Went Wrong",
        message: "We encountered an unexpected error while loading the company data. Our team has been notified.",
        action: {
            label: "Go to Home",
            href: "/"
        }
    };

    // Customize error based on cause
    if (error.cause === 403) {
        errorProps = {
            code: 403,
            title: "Access Denied",
            message: "You don't have permission to view this company. Please contact support if you think this is a mistake.",
            action: {
                label: "Go to Companies",
                href: "/company"
            }
        };
    } else if (error.message?.includes('network') || error.cause === 'NetworkError') {
        errorProps = {
            code: 500,
            title: "Connection Error",
            message: "We're having trouble connecting to our servers. Please check your internet connection and try again.",
            action: {
                label: "Try Again",
                href: window.location.pathname
            }
        };
    }

    return <ErrorPage {...errorProps} />;
}